import {
  Box,
  Stack,
  Tab,
  Tabs,
} from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { AircraftMappingTab } from "./FAAMapping/AircraftMappingTab";
import { BlacklistTab } from "./FAAMapping/BlacklistTab";
import { PendingApprovalsTab } from "./FAAMapping/PendingApprovalsTab";
import { TailMappingTab } from "./FAAMapping/TailMappingTab";
import { TailRequestsTab } from "./FAAMapping/TailRequestsTab";

type Props = {};

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`faa-mapping-tabpanel-${index}`}
      aria-labelledby={`faa-mapping-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `faa-mapping-tab-${index}`,
    'aria-controls': `faa-mapping-tabpanel-${index}`,
  };
}

export const FAAMapping: React.FC<Props> = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = React.useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Stack direction="column" spacing={0} width="100%" sx={{ height: '100%' }}>
      {/* Tab Navigation */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label={t("screens.faaMapping.ariaLabel")}
        >
          <Tab
            label={t("screens.faaMapping.tabs.aircraftMapping")}
            {...a11yProps(0)}
            sx={{ textTransform: 'none', fontWeight: 'medium' }}
          />
          <Tab
            label={t("screens.faaMapping.tabs.tailManualAdd")}
            {...a11yProps(1)}
            sx={{ textTransform: 'none', fontWeight: 'medium' }}
          />
          <Tab
            label={t("screens.faaMapping.tabs.blacklist")}
            {...a11yProps(2)}
            sx={{ textTransform: 'none', fontWeight: 'medium' }}
          />
          <Tab
            label={t("screens.faaMapping.tabs.tailRequests")}
            {...a11yProps(3)}
            sx={{ textTransform: 'none', fontWeight: 'medium' }}
          />
          <Tab
            label={t("screens.faaMapping.tabs.pendingApprovals")}
            {...a11yProps(4)}
            sx={{ textTransform: 'none', fontWeight: 'medium' }}
          />
        </Tabs>
      </Box>

      {/* Tab Content */}
      <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
        <CustomTabPanel value={activeTab} index={0}>
          <AircraftMappingTab />
        </CustomTabPanel>
        <CustomTabPanel value={activeTab} index={1}>
          <TailMappingTab />
        </CustomTabPanel>
        <CustomTabPanel value={activeTab} index={2}>
          <BlacklistTab />
        </CustomTabPanel>
        <CustomTabPanel value={activeTab} index={3}>
          <TailRequestsTab />
        </CustomTabPanel>
        <CustomTabPanel value={activeTab} index={4}>
          <PendingApprovalsTab />
        </CustomTabPanel>
      </Box>
    </Stack>
  );
};
